import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../../requestOptions';

export type CategoryPlanLinkData = Readonly<{
  run_id: number;
  subscription_id: number;
  suggestions_linked: number;
  already_linked: boolean;
}>;

export async function linkCategoryPlanRun(
  scope: RequestScope,
  args: { runId: number; subscriptionId: number },
  options: WriteRequestOptions
): Promise<ChannelApiResponse<CategoryPlanLinkData>> {
  try {
    const res = await scopedChannelApi(scope).post<CategoryPlanLinkData>(
      `atts/category-plan/runs/${args.runId}/link`,
      { subscription_id: args.subscriptionId },
      { ...options, headers: buildAsturHeaders() }
    );

    if (
      typeof res.data?.run_id !== 'number' ||
      typeof res.data?.subscription_id !== 'number' ||
      typeof res.data?.suggestions_linked !== 'number' ||
      typeof res.data?.already_linked !== 'boolean'
    ) {
      throw new Error('Invalid link response');
    }

    return { data: res.data, status: res.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
